namespace Areas.Requests {
    "use strict";


    export function gotoInspectionInProcessList() {
        location.href = "/Requests/List/InProcess";
    }

    export function gotoProjectWebsite() {
        var keyId: any = $('#ProjectInfoUpdateForm').dxForm('instance').option('AccountId');
        if (keyId != null) {
            var linkInfo = "https://project.capnet.ucla.edu/Account/CIB/View/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {  
            DevExpress.ui.notify("Record does not have an Account Link !", "warning", 2000);
        }
    }

    export function deleteInitiation() {
        const verifyDelete = window.confirm("Are you sure you would like to DELETE this record?");

        if (verifyDelete) {
            const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");

            const keyId: any = mainForm.option("ProjectInfoId");
            if (keyId != null) {
                sendRequest(`/Requests/Edit/Delete/${keyId}`, "", "DELETE");
            }
        }
    }

    export function saveInitiation() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const rechargeForm = $("#RechargeForm").dxForm("instance");
        const projectInfoId = mainForm.option("ProjectInfoId");

        let iRequestorScopeEditor: any = $('#RequestorScopeEditor').dxHtmlEditor('instance');
        let iRequestorScope = iRequestorScopeEditor.option("value");


        const newData: any = mainForm.option("formData");
        const rechargeData: any = rechargeForm.option("formData");
        const result: any = mainForm.validate();

        if (result.isValid) {
            newData.RequestorScope = iRequestorScope;
            newData.IsClientFunded = rechargeData.IsClientFunded;
            newData.FundingNotes = rechargeData.FundingNotes;

            sendRequest(`/Requests/Edit/Put/${projectInfoId}`, JSON.stringify(newData), "PUT");
        }

    }

    export function submitInitiation() {

        let iRequestorScopeEditor: any = $('#RequestorScopeEditor').dxHtmlEditor('instance');
        let iRequestorScope = iRequestorScopeEditor.option("value");

        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const rechargeForm = $("#RechargeForm").dxForm("instance");

        const newData: any = mainForm.option("formData");
        const rechargeData: any = rechargeForm.option("formData");
        const result: any = mainForm.validate();

        if (result.isValid) {
            newData.RequestorScope = iRequestorScope;
            newData.IsClientFunded = rechargeData.IsClientFunded;
            newData.FundingNotes = rechargeData.FundingNotes;

            sendRequest("/Requests/Edit/Submit", JSON.stringify(newData), "PUT");
        }
    }

    export function onRequestorScopeEditorContentReady(e: any) {
        var scopeDesc = e.component.option("requestorScopeDescription");
        e.component.option("value", scopeDesc);
    }

    export function onScopeEditorContentReady(e: any) {
        var scopeDesc = e.component.option("scopeDescription");
        e.component.option("value", scopeDesc);
    }

    export function gotoEditFromForm() {
        var keyId: any = $('#ProjectInfoUpdateForm').dxForm('instance').option('ProjectInfoId');
        if (keyId != null) {
            var linkInfo = "/Requests/Edit/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

    export function gotoReviewFromForm() {
        var keyId: any = $('#ProjectInfoUpdateForm').dxForm('instance').option('ProjectInfoId');
        if (keyId != null) {
            var linkInfo = "/Requests/Review/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

    export function reportFromForm() {
        var form = $('#ProjectInfoUpdateForm').dxForm('instance');

        Areas.gotoReport(
            "ProjectInitiationReport",
            () => { return form.option("ProjectInfoId"); },
            () => { return form.option("UserId") }
        );
    }

    export function onBeforeSendSave(e, f) {
        if (e === "update") {
            var grid = $("#BudgetGrid").dxDataGrid("instance");
            var projectInfoId = grid.option("ProjectInfoId");
            f.data.projectInfoId = projectInfoId;
        }
    }

    export function addAmendment(b) {
        var projectInfoId = b.component.option("ProjectInfoId");
        sendRequest(`/Requests/Review/AddAmendment/${projectInfoId}`, null, "PUT");
    }

    export function versionLink(cellElement, cellInfo) {
        var status = cellInfo.data.status;
        var userIsEditing = location.href.indexOf("Edit") >= 0;
        var userIsReviewing = location.href.lastIndexOf("Review") >= 0;
        let urlLink = "<a href= '/Requests/View/Index/{placeholder}'>View</a>";

        if (isReviewable(status) && userIsReviewing) {
            urlLink = "<a href= '/Requests/Review/Index/{placeholder}'>Review</a>";
        } else if (isEditable(status) && userIsEditing) {
            urlLink = "<a href= '/Requests/View/Index/{placeholder}'>View</a>";
        };

        buildCellContent(cellElement,
            () => { return cellInfo.key; },
            urlLink);
    }

    export function isEditable(status: string): boolean {
        return Constants.projectInfoEditableStatuses.indexOf(status) > -1;
    }

    export function isReviewable(status: string): boolean {
        return Constants.projectInfoReviewableStatuses.indexOf(status) > -1;
    }

    export function budgetEntry(cellElement, cellInfo) {

        if (cellInfo.data.entryAmount) {
            cellElement.html(cellInfo.text);
        }
        cellElement.css("background-color", "lightgoldenrodyellow");

    }

    export function onVersionCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }

        setRowBackground(e);
    }

    function setRowBackground(e: any) {
        var projectInfoId: number = e.component.option("ProjectInfoId") as number;

        if (e.data.projectInfoId === projectInfoId) {
            e.cellElement.css("background-color", "#FFA07A");
        }
    }
}